import axios from 'axios'
import store from '@/store'
import {
  objectToCamelCase,
} from '@/services/utils'

import { API_BASE, apiErrorHandler } from '../api'
import Auth from '../auth'

const ENDPOINT = `${API_BASE}org-report/`
const NOMINATIONS_ENDPOINT = `${API_BASE}nominations-report/`
const PARTICIPANT_SUMMARY_ENDPOINT = `${API_BASE}participant-summary-report/`
const GENERATE_EXPORT_DATASET_ENDPOINT = dataset => `${API_BASE}export-dataset/${dataset}/`

export default class ReportAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new ReportAPI(cls)
  }

  retrieve(organizationId, subOrgId, filter) {
    let params = filter
      ? Object.assign(
          {},
          {
            // Send the dates in YYYY-MM-DD format with no timezone

            startDate: filter.startDate.toISOString().split('T')[0],
            endDate: filter.endDate.toISOString().split('T')[0],
          },
        )
      : {}

    params = { ...params, suborganization_id: subOrgId }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: params,
    }

    const promise = store.state.axiosApi.get(`${ENDPOINT}${organizationId}/`, options)
    return promise
      .then(res => {
        return this.cls.fromAPI(res.data)
      })
      .catch(apiErrorHandler({ apiName: 'ReportAPI.retrieve' }))
  }

  retrieveNominations(organizationId, subOrgId, nominatorId, filter) {
    let params = filter
      ? Object.assign(
          {},
          {
            // Send the dates in YYYY-MM-DD format with no timezone

            startDate: filter.startDate.toISOString().split('T')[0],
            endDate: filter.endDate.toISOString().split('T')[0],
          },
        )
      : {}

    if(subOrgId)
      params = { ...params, suborganization_id: subOrgId }

    if(nominatorId)
      params = { ...params, nominator_id: nominatorId }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: params,
    }

    const promise = axios
      .get(`${NOMINATIONS_ENDPOINT}${organizationId}/`, options)
      .then(res => objectToCamelCase(res.data))
      .catch(apiErrorHandler({ apiName: 'ReportAPI.retrieveNominations' }))
    return promise
  }

  retreiveParticipantSummary(organizationId, subOrgId, filter) {
    let params = filter
    ? Object.assign(
        {},
        {
          // Send the dates in YYYY-MM-DD format with no timezone

          startDate: filter.startDate.toISOString().split('T')[0],
          endDate: filter.endDate.toISOString().split('T')[0],
        },
      )
    : {}

    if(subOrgId)
      params = { ...params, suborganization_id: subOrgId }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: params,
    }

    const promise = axios
      .get(`${PARTICIPANT_SUMMARY_ENDPOINT}${organizationId}/`, options)
      .then(res => objectToCamelCase(res.data))
      .catch(apiErrorHandler({ apiName: 'ReportAPI.retreiveParticipantSummary' }))
    return promise
  }

  exportDataset(dataset, filter=null) {
    let params = filter
      ? Object.assign(
          {},
          {
            // Send the dates in YYYY-MM-DD format with no timezone

            startDate: filter.startDate.toISOString().split('T')[0],
            endDate: filter.endDate.toISOString().split('T')[0],
          },
        )
      : {}

    const options = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: params,
    }
    // Data stream is accessed by creating a link on the fly and programmatically clicking it, so that
    // it opens a new window and executes an automatic download of the file.
    const promise = axios
      .get(GENERATE_EXPORT_DATASET_ENDPOINT(dataset), options)
      .then(response => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response.data]))
        let file_name = `${dataset}_DATASET__${new Date().toUTCString()}`
        link.setAttribute('download', file_name + '.csv')
        link.click()
      })
      .catch(apiErrorHandler({ apiName: 'ReportAPI.exportDataset' }))
    return promise
  }
}
